import React from 'react';
import AppLayout from 'layouts/AppLayout';
import Icon from 'components/AppIcon';

export default function FeatureFlagPlaceholder({ title, description, phase = 'Phase 2' }) {
  return (
    <AppLayout>
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="text-center max-w-sm">
          <div
            className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5"
            style={{ background: 'rgba(59,76,76,0.08)' }}
          >
            <Icon name="Lock" size={24} color="var(--color-primary)" />
          </div>
          <div
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-caption font-semibold mb-4"
            style={{ background: 'rgba(59,76,76,0.06)', color: 'var(--color-primary)', border: '1px solid rgba(59,76,76,0.15)' }}
          >
            <Icon name="Flag" size={11} color="var(--color-primary)" />
            {phase}
          </div>
          <h2 className="font-heading text-xl font-semibold text-foreground mb-2">{title}</h2>
          {description && (
            <p className="font-caption text-sm text-muted-foreground leading-relaxed">{description}</p>
          )}
        </div>
      </div>
    </AppLayout>
  );
}
